<template>
  <div class="home-card" :style="style">
    <slot name="header">
      <div class="home-card-header">
        <div class="header_title">{{ title }}</div>
      </div>
    </slot>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCard',
};
</script>

<script setup>
import { defineProps, computed, ref } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  styles: String,
});

const style = computed(() => {
  return props.styles;
});
</script>

<style lang="scss" scoped>
$headerHeight: 34px;
.home-card {
  // padding: 32px 24px;
  width: 480px;
  .home-card-header {
    width: 480px;
    height: $headerHeight;
    background: url('../assets/hs/bg_title2.png') no-repeat;
    background-size: 100% 100%;
    font-weight: 700;
    height: $headerHeight;
    line-height: $headerHeight;
    font-size: 16px;
    vertical-align: bottom;
    border-radius: 2px;
    color: #fff9f8;
    letter-spacing: 4px;
    position: relative;
    .header_title {
      padding-left: 16px;
      background: linear-gradient(to bottom, #f6feff, #82aeed);
      -webkit-background-clip: text; /* 使用文字作为背景的剪切区域 */
      -webkit-text-fill-color: transparent; /* 将文字颜色设为透明，使渐变背景可见 */
    }
  }
  .content {
    width: 100%;
    height: calc(100% - #{$headerHeight});
    padding-top: 12px;
    position: relative;
  }
}
</style>
